@if (enrolmentDto) {
  <div class="box ontario-margin-top-32-!">
    <div>
      <h4 class="border-bottom ontario-margin-bottom-24-!">
        {{'ClassEnrolment.RecordOfCompletion' | translate}}
        <span class="updated-text">
          {{'ClassEnrolment.SubmittedOn' | translate}}: {{enrolmentDto.SubmittedOn | utcToLocalDateTime : 'MMM dd, yyyy'}}
        </span>
      </h4>
    </div>
    <b>{{'ClassEnrolment.SendTo' | translate}}</b>
    <div class="field">
      <label>{{'ClassEnrolment.LearnersEmail' | translate}}</label>
      <app-checkbox [checked]="selection.email" (checkedChange)="selection.email=$event" [name]="enrolmentDto.EmailAddress"></app-checkbox>
    </div>
    <div class="field">
      <label>{{'ClassEnrolment.LearnersPhone' | translate}}</label>
      <app-checkbox [checked]="selection.phone" (checkedChange)="selection.phone=$event" [name]="formatUtil.formatPhoneNumber(enrolmentDto.Phone)!"></app-checkbox>
    </div>
    <div>
      <button class="grey-button" [disabled]="!(selection.email || selection.phone)" (click)="Send()">{{'ClassEnrolment.Send' | translate}}</button>
    </div>
    @if (email>0) {
      <div>
        @if (email==1) {
          <app-alert-banner bannerType="success" bannerText="{{'ClassEnrolment.RecordOfCompletionWillBeEmailedhortly' | translate}}"></app-alert-banner>
        }
        @if (email==2) {
          <app-alert-banner bannerType="error" bannerText="{{'General.TechnicalIssue' | translate}}"></app-alert-banner>
        }
      </div>
    }
    <div class="horizontal-rule"></div>
    <b>{{'ClassEnrolment.Download' | translate}}</b>
    <div class="field">
      <app-checkbox [checked]="selection.fullsize" (checkedChange)="selection.fullsize=$event" [name]="'ClassEnrolment.Fullsize' | translate"></app-checkbox>
    </div>
    <div class="field">
      <app-checkbox [checked]="selection.walletsize" (checkedChange)="selection.walletsize=$event" [name]="'ClassEnrolment.Walletsize' | translate"></app-checkbox>
    </div>
    <div class="">
      <button class="grey-button" [disabled]="!(selection.fullsize || selection.walletsize)" (click)="Download()">{{'ClassEnrolment.Download' | translate}}</button>
    </div>
    @if (download>0) {
      <div>
        @if (download==1) {
          <app-alert-banner bannerType="success" bannerText="{{'ClassEnrolment.RecordOfCompletionSuccessfullyDownload' | translate}}"></app-alert-banner>
        }
        @if (download==2) {
          <app-alert-banner bannerType="error" bannerText="{{'General.TechnicalIssue' | translate}}"></app-alert-banner>
        }
      </div>
    }
  </div>
}
